






















import { Vue, Component, Prop } from 'vue-property-decorator';
import ContractHistory from '@/domain/contract-history/entity/contract-history.entity';

@Component
export default class ManagementCalculationHistoryComponent extends Vue {
  @Prop({ required: true })
  historyContent!: ContractHistory;
}
